import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchContactCategories = createAsyncThunk('contactCategories/fetch', async (params = {}) => {
  const response = await api.get('/contact-categories', { params });
  return response.data;
});

export const createContactCategory = createAsyncThunk('contactCategories/create', async (data) => {
  const response = await api.post('/contact-categories', data);
  return response.data;
});

export const updateContactCategory = createAsyncThunk('contactCategories/update', async ({ id, data }) => {
  const response = await api.put(`/contact-categories/${id}`, data);
  return response.data;
});

export const deleteContactCategory = createAsyncThunk('contactCategories/delete', async (id) => {
  await api.delete(`/contact-categories/${id}`);
  return id;
});

const contactCategorySlice = createSlice({
  name: 'contactCategories',
  initialState: {
    items: [],
    total: 0,
    currentPage: 1,
    itemsPerPage: 50,
    totalPages: 0,
    loading: false,
    error: null
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchContactCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.categories;
        state.total = action.payload.total;
        state.totalPages = action.payload.pages;
        if (action.payload.page) {
          state.currentPage = action.payload.page;
        }
      })
      .addCase(fetchContactCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createContactCategory.fulfilled, (state, action) => {
        state.items.unshift(action.payload);
        state.total += 1;
      })
      .addCase(updateContactCategory.fulfilled, (state, action) => {
        const index = state.items.findIndex(c => c.id === action.payload.id);
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })
      .addCase(deleteContactCategory.fulfilled, (state, action) => {
        state.items = state.items.filter(c => c.id !== action.payload);
        state.total -= 1;
      });
  }
});

export const { setPage, clearError } = contactCategorySlice.actions;
export default contactCategorySlice.reducer;